// extracted by mini-css-extract-plugin
module.exports = {"overview-table":"styles-module__overview-table___oi22z"};